export default __webpack_public_path__ + "static/media/books2-afterB-1920w.a755ac95.png";